<!--
  navItem „Berechnung“ — Relevanz, Provisionsbasis und Basisbeträge.
  Die fünf nullbaren Rechenfelder tragen pro Feld die Tatsachenaussage „nicht berechnet“;
  die Erklärung „Diese Werte ergänzt der nächste Berechnungslauf.“ steht einmal am Blockkopf.
  „Berater ermittelt“ zeigt sein echtes „Nein“, sobald der Vertrag keine Provisionssätze hat;
  der Hinweis erscheint dort nur, solange Sätze existieren und das Kennzeichen noch ungestempelt ist.
-->
<div class="cp-provision-contract-calculation">

    @if (!initialized || busy) {
        <p-skeleton height="12rem"></p-skeleton>
    } @else {
        <cp-provision-object-data
                objectType="cp.ProvisionContract"
                [objectId]="provisionContractId"
                widgetAlias="cp.provisionContract.calculation"
                widgetTitle="Berechnung"
                [fields]="fields"
                [pendingFields]="pendingFields"
                [pendingFalseFields]="pendingFalseFields"
                [columns]="columns"
                emptyText="Keine Provisionszeile ausgewählt.">
        </cp-provision-object-data>
    }

</div>
